import { connect } from 'react-redux';
import { goToOrderDetails } from '../../../../../../store/orders/order-details/orders.details.actions';

import { AnchorEmbeddedCustomAlert } from './index';

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClick: () => {
      dispatch(goToOrderDetails({ salesOrderId: ownProps.salesOrderID }));
    },
  };
};

export const AnchorEmbeddedCustomAlertContainer = connect(null, mapDispatchToProps)(AnchorEmbeddedCustomAlert);
